	import { Component, SellerService, BaseTLDetailComponent, AxiosResponse } from "../../../Infrastructure/CorBase/CoreBase";


	export default abstract class  SellerDetailBase extends BaseTLDetailComponent {

		sellerService: SellerService = new SellerService();

		createdBase() {
			
			if (this.styleFormNew) {
				this.formData.validFrom = this.getCurrentDate();
				this.formData.name = (this.$router.currentRoute.params.item as any).name;
				this.formData.dic = (this.$router.currentRoute.params.item as any).dic;
				this.formData.ic = (this.$router.currentRoute.params.item as any).ic;
			}
		}

		getCurrentDate = (): string => {
			const date = new Date();
			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, '0'); // měsíc je 0-indexovaný, proto přidáváme 1
			const day = date.getDate().toString().padStart(2, '0');
			var result = `${year}-${month}-${day}`;
			return result;
		};

		formData = {
			id: 0,
			name: '',
			description: '',
			ic: '',
			dic: '',
			addressPostalCode: '',
			addressCity: '',
			addressDistrict: '',
			addressStreet: '',
			validFrom:'' ,
			validTo: '',
			idAddresspoint: 0
		};



		protected doAction() {
			super.doCRUDActionWithInfoMessage(this.$t('seller.messageNew').toString(), this.$t('seller.messageEdit').toString(), this.$t('seller.messageDelete').toString());
		}

		protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
			return this.sellerService.getById(this.objectId);
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall()
		}

		protected refreshItems(items: any, refreshData: any): any {
			return items;
		}

		protected processResponse(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
			this.formData.name = response.data.name;
			this.formData.validFrom = response.data.validFrom != null ? response.data.validFrom.substring(0, 10) : '';
			this.formData.validTo = response.data.validTo != null ? response.data.validTo.substring(0, 10) : '';
			this.formData.description = response.data.description;
			this.formData.ic = response.data.ic;
			this.formData.dic = response.data.dic;
			this.formData.addressPostalCode = response.data.addressPostalCode;
			this.formData.addressCity = response.data.addressCity;
			this.formData.addressDistrict = response.data.addressDistrict;
			this.formData.addressStreet = response.data.addressStreet;
		}

		protected afterCreate(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
		}

		protected updateObject(): Promise<AxiosResponse<any>> {
			this.prepareFormData();
			return this.sellerService.update(this.objectId, this.formData)
		}

		protected createObject(): Promise<AxiosResponse<any>> {		
			this.prepareFormData();
			return this.sellerService.create(this.formData);
		}

		protected deleteObject(): Promise<AxiosResponse<any>> {
			return this.sellerService.delete(this.objectId);
		}

		prepareFormData() {
			if (this.formData.validFrom == '') {
				//@ts-ignore
				delete this.formData.validFrom;
			}
			if (this.formData.validTo == '') {
				//@ts-ignore
				delete this.formData.validTo;
			}
		}

		vIsCorrectName: boolean = true;
		vIsCorrectDate: boolean = true;
		vIsMinDate: boolean = true;
		vIsMaxDate: boolean = true;
		vIsCorrectIc: boolean = true;
		vIsCorrectDic: boolean = true;

		vIsCorrectDisctinct: boolean = true;
		vIsCorrectCity: boolean = true;
		vIsCorrectPostalCode: boolean = true;
		vIsCorrectStreet: boolean = true;

		protected validateBase() {
			return !(this.vIsCorrectName && this.vIsCorrectDate && this.vIsMinDate && this.vIsMaxDate && this.vIsCorrectIc && this.vIsCorrectDic
				&& this.vIsCorrectDisctinct && this.vIsCorrectStreet && this.vIsCorrectCity && this.vIsCorrectPostalCode);
		}

		//bohužel to jinak nešlo
		requiredDateTo() {
			if (this.formData.validTo == "" || this.formData.validTo == undefined) {
				this.vIsMaxDate = true;
				return false;
			}
			else {
				return true;
			}
		}

		requiredDateFrom() {
			if (this.formData.validFrom == "" || this.formData.validFrom == undefined) {
				this.vIsMinDate = true;
				return false;
			}
			else {
				return true;
			}
		}

		protected isCorrectNameBase(value: any) {
			this.vIsCorrectName = value;
		}
		protected isCorrectDateBase(value: any) {
			this.vIsCorrectDate = value;
		}

		protected isCorrectMinDateBase(value: any) {
			this.vIsMinDate = value;
		}

		protected isCorrectMaxDateBase(value: any) {
			this.vIsMaxDate = value;
		}
		protected isCorrectDicBase(value: any) {
			this.vIsCorrectDic = value;
		}
		protected isCorrectIcBase(value: any) {
			this.vIsCorrectIc = value;
		}

		protected isCorrectCityBase(value: any) {
			this.vIsCorrectCity= value;
		}

		protected isCorrectStreetBase(value: any) {
			this.vIsCorrectStreet= value;
		}

		protected isCorrectPostalCodeBase(value: any) {
			this.vIsCorrectPostalCode = value;
		}

		protected isCorrectDistinctBase(value: any) {
			this.vIsCorrectDisctinct = value;
		}
	}
